import React from 'react';
import { Button } from 'react-bootstrap';
import { reportUnexpected } from '../sentry';

export class ErrorBoundary extends React.Component<
  { history?: any },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    reportUnexpected(error, { componentStack: errorInfo?.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="m-5 text-center">
          <img alt="support" src="./assets/images/404.png" width={800} />
          <h5>Something went wrong on this screen — please refresh.</h5>
          <p>Our team has been notified. Your work is still saved.</p>
          <Button className="my-3" onClick={() => (window.location.href = '/')}>
            Go back
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
